import { render } from "./Principal.vue?vue&type=template&id=49b86e52&scoped=true"
import script from "./Principal.vue?vue&type=script&lang=js"
export * from "./Principal.vue?vue&type=script&lang=js"

import "./Principal.vue?vue&type=style&index=0&id=49b86e52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b86e52"]])

export default __exports__